<!-- header title and station selection -->
<div style="float:left">
	<h3>Station {{stationID}} Dashboard</h3>
</div>

<div class="col-md-4 form-group" class="horizontal spaceLeft spaceTop" id="selDiv">
	<!-- station selection list -->
	<p-select [options]="stationList" [(ngModel)]="listSelection" [style]="{'width':'600px'}" 
		(ngModelChange)="newStationSelected($event)" [filter]="true">
		<ng-template let-station pTemplate="item">
			<div class="ui-helper-clearfix" style="position: relative;height: 20px;">	
            			<div class="{{station.novaScoreClass}} stationListElement">{{station.label}}</div>
        		</div>
		</ng-template>
	</p-select>

	<!-- hamburger download button-->
    <p-menu #menu [popup]="true" [model]="dataAccessOptions" appendTo="body" class="spaceLeft"></p-menu>
    <button id='dataAccessButton' type="button" pButton icon="pi pi-bars" (click)="menu.toggle($event)"></button>
</div>

<!-- general station information -->
<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
<div class="row stationsClass">
	<div id="infoDivs">
		<!-- div class="col-md-6" id="StationInformation"> -->
		<div id="StationInformation">
  			Station name: {{currentStation.stationName}}<br>
  			Station elevation: {{currentStation.stationElevation}}
  			<li *ngFor="let novascore of stationNovaScores">
  				<span class={{novascore.novaScoreClass}}>{{novascore.dataType}} - {{novascore.novaScoreDescription}}</span>
  			</li>
		</div>
		<div id="pictures">
			<lib-image-viewer [images]="images" [header]="currentStation.stationName"></lib-image-viewer>
		</div>

	</div>

	<div>
	</div>

	<!-- 
	<p-button icon="pi pi-cog" (onClick)="toggleTools()"></p-button>
	<div *ngIf="showTools">
	-->
		<!-- period of record selection box -->
		<div style="clear:both"></div>
		<div class="col-md-6" class="moreSpaceTop horizontal">
			<label class="spaceRight">Period of record:</label>
			<p-select [options]="periodOfRecordList"
				[scrollHeight]="'250px'"
				[(ngModel)]='periodOfRecordSelected'
				(ngModelChange)='newPeriodOfRecordSelected($event)' >
			</p-select>
		</div>
		<span *ngIf="periodOfRecordSelected=='0'">
			<span class="spaceLeft"> Start date: </span>
			<p-datepicker [(ngModel)]="startDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
			<span class="spaceLeft"> End date: </span>
			<p-datepicker [(ngModel)]="endDate" dateFormat="yy-mm-dd" showTime="true" hourFormat="24" showIcon="true"></p-datepicker>
			<button pButton type="button" label="Show Data" title="Update Charts" class="spaceLeft" style="vertical-align: inherit"(click)="newPeriodOfRecordSelected('0')"></button>
		</span>

		<div class="spaceTop">
		<label class="spaceRight">Tracker:</label>
		<p-select [options]="trackerOptions"
			[(ngModel)]='tooltipPreference'
			(onChange)='tooltipPreferenceChanged($event)' >
		</p-select>
		</div>

		<!-- 
			<button pButton pRipple type="button" 
				icon="pi pi-undo"
				class="p-button-rounded p-button-text p-button-plain"
				(click)="resetZoom">
			</button>
		-->
	<!-- 
	</div>
	-->
</div>

<!-- time series charts -->
<div style="clear:both"></div>  <!-- puts items in following div on new lines -->
<div id="container" class="row stationsClass">
</div>

<!-- alarm table -->
<p-panel *ngIf="alarmList.length > 0" header="Alarms" [toggleable]="true">
	<p-table [value] = "alarmList">
		<ng-template pTemplate="header">
			<tr>
				<th>Data Type</th>
				<th>Date/Time</th>
				<th>Alarm Name</th>
				<th>Trigger Value</th>
				<th>Alarm State</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-alarm>
			<tr>
				<td>{{alarm.dataType}}</td>
				<td>{{alarm.alarmDateTime | date:"medium"}}</td>
				<td>{{alarm.alarmName}}</td>
				<td>{{alarm.triggerValue}}</td>
				<td>{{alarm.alarmState}}</td>
			</tr>
		</ng-template>
	</p-table>
</p-panel>
	
